<script>
export default {
  name: "PartnersPage",
  data() {
    return {
      imgSrc: require('@/assets/images/partner/PP-graphics-home-imgm-06.png'),
      isImageLoaded: false,
    }
  },
  created() {
    // 预加载图片
    this.preloadImage(this.imgSrc)
  },
  methods: {
    preloadImage(src) {
      const img = new Image()
      img.onload = () => {
        this.isImageLoaded = true
      }
      img.src = src
    },
  },
  computed:{
    benefitsList(){
      return [
        this.$t('partners.opportunities1'),
        this.$t('partners.opportunities2'),
        this.$t('partners.opportunities3'),
        this.$t('partners.opportunities4')
      ]
    }
  }
}
</script>

<template>
<div class="partner-container">
<!--  <div class="big-image">-->
<!--    <div v-if="!isImageLoaded" class="image-loading">-->
<!--      <i class="el-icon-loading loading-icon"></i>-->
<!--    </div>-->
<!--    <el-image v-else :src="imgSrc" fit="contain" class="fade-in-image"/>-->
<!--  </div>-->
  <div class="top-wrap">
    <h1>{{$t('partners.partnerTitle')}}</h1>
  </div>
  <div class="partner-wrap">
    <div class="" style="width: 100%;">
      <div class="partner-benefits-section">
        <div class="section-top">
          <img class="mw-100 m-img" src="@/assets/images/partner/Group 1090.png" alt="">
          <div>
            <p class="">{{$t('partners.partnerIntro')}}</p>
            <div class="benefits-list">
              <h2>{{$t('partners.opportunities')}}</h2>
              <ul class="list mt-3">
                <li v-for="item in benefitsList" :key="item">
                  <img src="@/assets/images/icon/Ellipse 1.png" alt="">
                  <span>{{item}}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="m-pt2" style="margin-top: 8%;">
          <h2>{{$t('partners.together')}}</h2>
        </div>
        <div class="cta-button-wrapper" style="margin-top: 5%">
          <a href="mailto:marketing@monkeytree.com.hk">{{$t('contact.contactUs')}}</a>
        </div>
      </div>
    </div>
  </div>
  <div style="margin-bottom: 20%">
    <img class="mw-100 vertical-middle" src="@/assets/images/partner/top-Asset 17.png" alt="">
    <div style="background: #fff9dd; padding: 5% 0 6%">
      <div class="container">
        <div class="partner-wrap">
          <h1>{{$t('partners.ourPartners')}}</h1>
          <p class="m-pt text-center" v-html="$t('partners.ourPartnersIntro')"></p>
        </div>
      </div>
    </div>
    <div class=" m-ip text-center" style="padding: 0px">
      <img class="mw-100" src="@/assets/images/partner/partner.png" alt="">
    </div>
<!--    <img class="mw-100 vertical-middle" src="@/assets/images/partner/bottom-Asset 17.png" alt="">-->
  </div>

</div>
</template>

<style scoped lang="scss">
@use '@/styles/responsive.scss' as *;
.partner-container{
  width: 100%;
  .big-image{
    min-height: 70vh; /* 设置最小高度，确保布局稳定的同时允许内容扩展 */
    //display: flex;
    //align-items: center;
    //justify-content: center;
    overflow: hidden;
    position: relative;
    @include media-max(sm){
      min-height: 30vh;
    }
  }
  .top-wrap{
    background: #ffe502;
    padding: 231px 0 100px 0;
    h1{
      color: #01903E;
      font-size: 80px;
      line-height: 70px;
      text-align: center;
    }
  }
  .partner-wrap{
    display: flex;
    align-items: center;
    flex-direction: column;
    //margin-top: 7%;
    //margin-bottom: 20%;
    h1{
      color: #158800;
      font-size: 45px;
      line-height: 104px;
    }
    p{
      font-size: 20px;
      line-height: 32px;
    }
    .partner-benefits-section{
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 86px 0 267px;
      .section-top{
        display: flex;
        padding-left: 172px;
        padding-right: 282px;
        align-items: flex-start;
        column-gap: 70px;
        //background: #ffe502;
        //padding: 20px 30px;
        //font-size: 35px;
        //line-height: 70px;
        //font-weight: 800;
        //user-select: none;
        //border-radius: 59px;
        //color: #01903E;
      }
      h2{
        font-size: 35px;
        line-height: 70px;
        font-weight: 800;
        color: #01903E;
      }
      .benefits-list{
        margin-top: 4.5%;
        .list{
          li{
            display: flex;
            align-items: flex-start;
            margin-left: 1%;
            img{
              margin-top: 1.5%;
            }
            span{
              margin-left: 1%;
              font-size: 20px;
              line-height: 2;
              color: #5A2A00
            }
          }
        }
      }
      .cta-button-wrapper{
        a{
          background: #01903e;
          padding: 16px 100px;
          font-size: 33px;
          line-height: 70px;
          color: #FFFFFF;
          border-radius: 35px;
        }
      }
    }
  }
  @include media-max(xxl){
    .partner-wrap{
      .partner-benefits-section{
        .section-top{
          padding: 0 20px;
        }
        .benefits-list{
          .list{
            li{
              display: flex;
              align-items: flex-start;
              margin-left: 1%;
              img{
                margin-top: 2%;
              }
            }
          }
        }
      }
    }
  }
  @include media-max(xl){
    .partner-wrap{
      .partner-benefits-section{
        .benefits-list{
          .list{
            li{
              display: flex;
              align-items: flex-start;
              img{
                margin-top: 3.2%;
              }
            }
          }
        }
      }
    }
  }
  @include media-max(lg){
    margin-top: 108px;
  }
  @include media-max(md){
    margin-top: 148px;

  }
  @include media-max(sm){
    margin-top: 111px;
  }
}
/* 图片淡入动画 */
.fade-in-image{
  opacity: 0;
  animation: fadeIn 0.5s ease-in forwards;
}

/* 加载状态 */
.image-loading{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #009344;
}

.loading-icon{
  font-size: 48px;
  animation: rotate 2s linear infinite;
}

/* 淡入动画 */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* 旋转动画 */
@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
@include media-max(lg){
  .partner-container{
    .top-wrap{
      padding: 44px 0 44px 0;
    }
    .partner-wrap{
      margin-bottom: 10%;
      .m-pt{
        margin-top: 23px;
        padding: 0 30px;
      }
      .m-ip{
        padding: 0 10px !important;
      }
      .partner-benefits-section{
        .section-top{
          padding: 0 55px;
          flex-direction: column;
          align-items: center;
          //justify-content: center;
          p{
            margin-top: 5%;
            text-align: center;
          }
        }
        h2{
          font-size: 30px !important;
          line-height: 60px !important;
        }
        //.section-top{
        //  padding: 15px 25px;
        //}
        .m-iw{
          width: 80% !important;
        }
        .benefits-list{
          padding: 0 40px;
          margin-top: 6.5%;
          .list{
            li{
              img{
                margin-top: 2%;
              }
            }
          }
        }
        .cta-button-wrapper{
          a{
            padding: 12px 100px;
            font-size: 20px;
            line-height: 30px;
          }
        }
      }
    }
  }
}
@include media-max(md){
  .partner-container{
    .partner-wrap{

      .partner-benefits-section{
        padding: 50px 0 100px;
        .section-top{
          padding: 0 55px;
          flex-direction: column;
          align-items: center;
          //justify-content: center;
          .m-img{
            width: 90%;
          };
          p{
            font-size: 12px;
          }
        }
        h2{
          font-size: 20px !important;
          line-height: 24px !important;
        }
        //.section-top{
        //  padding: 10px 20px;
        //}
        .m-iw{
          width: 85% !important;
        }
        .benefits-list{
          .list{
            li{
              img{
                margin-top: .5%;
              }
              span{
                font-size: 12px;
                line-height: 20px;
                color: #5A2A00
              }
            }
          }
        }
        .m-pt{
          font-size: 12px !important;
        }
        .m-pt2{
          padding: 0 40px;
        }
        .cta-button-wrapper{
          a{
            padding: 10px 50px;
            font-size: 12px;
            line-height: 20px;
          }
        }
      }
      .m-pt{
        font-size: 12px;
      }
    }
  }
}
@include media-max(sm){
  .partner-container{
    .partner-wrap{
      .partner-benefits-section{
        .benefits-list{
          padding: 0;
          .list{
            li{
              img{
                margin-top: .5%;
              }

            }
          }
        }
        .m-pt{
          font-size: 12px !important;
        }
        .m-pt2{
          padding: 0 55px;
        }
      }
    }
  }
}
</style>>